/** Phase-1 catalog seed — used when KPI catalog APIs are not yet deployed. */
export const KPI_CATALOG_SEED = Object.freeze([
  {
    kpi_code: "on_time_pickup",
    display_name: "On-Time Pickup",
    kind: "base",
    category: "performance",
    description:
      "Share of pickups completed within the configured grace window after the scheduled pickup time.",
    enabled: true,
    supported_dimensions: ["date", "carrier", "office", "lane"],
    measures: ["total_events", "success_events", "rate_pct"],
    last_etl_at: null,
    selection_variants: [
      {
        variant_code: "on_time_pickup_7d",
        display_name: "On-Time Pickup (7 days)",
        scoring_weight_key: "on_time_pickup_7d",
        carrier_kpi_name: "on_time_pickup_7d",
        fixed_dimensions: { rolling_window_days: 7, office_scoped: true },
        used_in_selection: true,
      },
      {
        variant_code: "on_time_pickup_90d",
        display_name: "On-Time Pickup (90 days)",
        scoring_weight_key: "on_time_pickup",
        carrier_kpi_name: "on_time_pickup",
        fixed_dimensions: { rolling_window_days: 90, office_scoped: true },
        used_in_selection: true,
      },
    ],
  },
  {
    kpi_code: "on_time_delivery",
    display_name: "On-Time Delivery",
    kind: "base",
    category: "performance",
    description: "Share of deliveries completed on or before the committed delivery date.",
    enabled: false,
    supported_dimensions: ["date", "carrier", "office", "lane"],
    measures: ["total_events", "success_events", "rate_pct"],
    last_etl_at: null,
    selection_variants: [
      {
        variant_code: "on_time_delivery_90d",
        display_name: "On-Time Delivery (90 days)",
        scoring_weight_key: "otd",
        carrier_kpi_name: "otd",
        fixed_dimensions: { rolling_window_days: 90, office_scoped: true },
        used_in_selection: true,
      },
    ],
  },
  {
    kpi_code: "acceptance_rate",
    display_name: "Acceptance Rate",
    kind: "base",
    category: "engagement",
    description: "Share of tender offers accepted by the carrier within the response window.",
    enabled: false,
    supported_dimensions: ["date", "carrier", "office"],
    measures: ["total_events", "success_events", "rate_pct"],
    last_etl_at: null,
    selection_variants: [
      {
        variant_code: "acceptance_rate_90d",
        display_name: "Acceptance Rate (90 days)",
        scoring_weight_key: "acceptance_rate",
        carrier_kpi_name: "acceptance_rate",
        fixed_dimensions: { rolling_window_days: 90, office_scoped: true },
        used_in_selection: true,
      },
    ],
  },
]);

export const KPI_DIMENSION_LABELS = Object.freeze({
  date: "Date",
  carrier: "Carrier",
  office: "Office",
  lane: "Lane",
  origin: "Origin",
  destination: "Destination",
});

export const KPI_MEASURE_LABELS = Object.freeze({
  total_events: "Total events",
  success_events: "Success events",
  rate_pct: "Rate %",
});

/** Dimensions available when defining a base KPI grain. */
export const GLOBAL_KPI_DIMENSIONS = Object.freeze([
  "date",
  "carrier",
  "office",
  "lane",
  "origin",
  "destination",
]);

export const GLOBAL_KPI_MEASURES = Object.freeze([
  "total_events",
  "success_events",
  "rate_pct",
]);

export const KPI_CATEGORIES = Object.freeze([
  { value: "performance", label: "Performance" },
  { value: "engagement", label: "Engagement" },
  { value: "cost", label: "Cost" },
  { value: "quality", label: "Quality" },
]);

/** Common rolling windows for selection variants. */
export const ROLLING_WINDOW_PRESETS = Object.freeze([
  { value: 7, label: "7 days" },
  { value: 30, label: "30 days" },
  { value: 90, label: "90 days" },
  { value: 180, label: "180 days" },
  { value: 365, label: "365 days (1 year)" },
]);
